module.exports = __webpack_public_path__ + "static/media/collaborative-document.06c50f14.svg";